import React, { Component } from 'react';
import { Input, message, Table } from 'antd';
import moment from 'moment';
import util from '@util/index';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleMouseEnter = (record, rowIndex, op) => {
    const list = this.props.data;
    list[rowIndex][`is${op}Editable`] = true;
    this.props.onChange(list);
  };

  handleMouseLeave = (record, rowIndex, op) => {
    const list = this.props.data;
    list[rowIndex][`is${op}Editable`] = false;
    this.props.onChange(list);
  };

  handleNumChange = (op, rowIndex) => e => {
    const list = this.props.data;
    const oldValue = list[rowIndex][op];
    list[rowIndex][op] = e.target.value;

    const confirm = Math.abs(list[rowIndex].confirm) || 0;
    const price = list[rowIndex].price || 0;
    const refund = list[rowIndex].refund || 0;
    const damages = list[rowIndex].damages || 0;
    const obsolete = list[rowIndex].obsolete || 0;
    const flag = +confirm < +damages + +refund || +price < +obsolete;

    if (flag) {
      message.warn('输入与合同款不符');
      list[rowIndex][op] = oldValue;
      return;
    }

    this.props.onChange(list);
  };

  columns = () => {
    const type = ['押金', '工位', '地址'];
    return [
      {
        title: '账单编号',
        dataIndex: 'payableNo',
      },
      {
        title: '账单类型',
        dataIndex: 'type',
        render: (text, record) => <span>{record.payType === 2 ? '退款' : type[text]}</span>,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '付款时间',
        dataIndex: 'date',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '待收/退',
        dataIndex: 'price',
        render: (text, record) => {
          const element =
            record.payType === 2 ? (
              <span style={{ color: 'red' }}>退{util.numberFormat(text)}</span>
            ) : (
              <span style={{ color: 'green' }}>收{util.numberFormat(text)}</span>
            );
          return text > 0 ? element : 0;
        },
      },
      {
        title: '实收/退',
        dataIndex: 'confirm',
        render: (text, record) => {
          const element =
            record.payType === 2 ? (
              <span style={{ color: 'red' }}>退{util.numberFormat(text)}</span>
            ) : (
              <span style={{ color: 'green' }}>收{util.numberFormat(text)}</span>
            );
          return text > 0 ? element : 0;
        },
      },
      {
        title: '作废',
        dataIndex: 'obsolete',
        render: (text, record, index) => {
          return record.price > 0 && record.payType !== 2 ? (
            <div>
              {record.isObsoleteEditable ? (
                <Input
                  value={text}
                  onChange={this.handleNumChange('obsolete', index)}
                  onBlur={() => this.handleMouseLeave(record, index, 'Obsolete')}
                />
              ) : (
                <a onClick={() => this.handleMouseEnter(record, index, 'Obsolete')}>
                  {text || '作废'}
                </a>
              )}
            </div>
          ) : null;
        },
      },
      {
        title: '违约金',
        dataIndex: 'damages',
        render: (text, record, index) =>
          record.type === 0 && record.confirm > 0 && record.payType !== 2 ? (
            <div>
              {record.isDamagesEditable ? (
                <Input
                  value={text}
                  onChange={this.handleNumChange('damages', index)}
                  onBlur={() => this.handleMouseLeave(record, index, 'Damages')}
                />
              ) : (
                <a onClick={() => this.handleMouseEnter(record, index, 'Damages')}>
                  {text || '转违约金'}
                </a>
              )}
            </div>
          ) : null,
      },
      {
        title: '退回',
        dataIndex: 'refund',
        render: (text, record, index) =>
          record.confirm > 0 && record.payType !== 2 ? (
            <div>
              {record.isRefundEditable ? (
                <Input
                  value={text}
                  onChange={this.handleNumChange('refund', index)}
                  onBlur={() => this.handleMouseLeave(record, index, 'Refund')}
                />
              ) : (
                <a onClick={() => this.handleMouseEnter(record, index, 'Refund')}>
                  {text || '退回'}
                </a>
              )}
            </div>
          ) : null,
      },
    ];
  };

  render() {
    const list = this.props.data || [];
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={false}
        onChange={this.onTableChange}
        rowKey="uuid"
      />
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/TablePayable.js